import { useState, useEffect } from "react";
import { GoogleLogin, googleLogout } from "@react-oauth/google";
import { apiFetch } from "./api";

const AUTH_STATE_EVENT = "lester-auth-state-change";
const AUTH_STATE_STORAGE_KEY = "lester-auth-state-version";

const notifyAuthStateChanged = () => {
    try {
      localStorage.setItem(AUTH_STATE_STORAGE_KEY, String(Date.now()));
    } catch (error) {
      // Ignore storage sync failures and still notify this tab.
    }
    window.dispatchEvent(new Event(AUTH_STATE_EVENT));
};

const AuthTokenRetrieve = () =>{
    const [shouldShow, setShouldShow] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        const validateToken = () => {
          setIsLoading(true);
          apiFetch("/food/access")
            .then((response) => response.json())
            .then((data) => {
              setShouldShow(!!data?.authenticated);
              setIsLoading(false);
            })
            .catch(() => {
              setShouldShow(false);
              setIsLoading(false);
            });
        };

        validateToken();
        window.addEventListener("storage", validateToken);
        window.addEventListener(AUTH_STATE_EVENT, validateToken);

        return () => {
          window.removeEventListener("storage", validateToken);
          window.removeEventListener(AUTH_STATE_EVENT, validateToken);
        };
      }, []);

    return { shouldShow, isLoading };
}
const LoginButton = (props)=>{
    const {setShouldShow} = props;
    const [errorText, setErrorText] = useState('');
    const errorMessage = (error) => {
        console.log(error);
      };
    const responseMessage = (response) => {

        const requestOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ credential: response.credential }),
        };

        apiFetch("/food/access", requestOptions)
          .then((response) => response.json())
          .then((data) => {
            if (data?.authenticated) {
              notifyAuthStateChanged();
              setShouldShow(true);
            } else {
              setShouldShow(false);
              setErrorText(data?.error || "User not authorized");
            }
          })
          .catch(() => {
            setShouldShow(false);
            setErrorText("Sign-in failed");
          });
      };

    return (
        <div style={{ width: "300px" }}>
          <p>{errorText ? errorText : ""}</p>
          <GoogleLogin onSuccess={responseMessage} onError={errorMessage} />
        </div>
    )
}
const LogoutButton = (props)=>{
    const{setShouldShow = () => {}} = props;
    const logOut = () => {
        googleLogout();
        apiFetch("/food/access", { method: "DELETE" })
          .finally(() => {
            setShouldShow(false);
            notifyAuthStateChanged();
          });
      };
    return( 
        <button className="summaryButton" onClick={logOut}>
            Log out
        </button>)
    
}
export {
    AuthTokenRetrieve,
    LoginButton,
    LogoutButton,
    notifyAuthStateChanged
  }
